<template xmlns:vertical-align="http://www.w3.org/1999/xhtml">
    <div :class="$style.container"
         v-loading.fullscreen.lock.body="loading"
         element-loading-text="拼命加载中"
         element-loading-spinner="el-icon-loading"
         element-loading-background="rgba(0, 0, 0, 0.8)">

        <el-row>
            <el-col :span="24">
                <div align="center">
                    <el-button-group :class="$style.month" class="a_modal">
                        <el-button size="small" icon="el-icon-arrow-left"
                                   @click.stop="lastNextMonthClick(-1)"></el-button>
                        <el-button size="small" disabled>{{dateStr}}</el-button>
                        <el-button size="small" icon="el-icon-arrow-right"
                                   @click.stop="lastNextMonthClick(1)"></el-button>
                    </el-button-group>
                </div>
            </el-col>

            <div style="width: 100%">

                <el-form>

                    <el-col v-for="(item, index) in tableQuarterData" :key="index" :label="item" :span="8">
                        <el-form-item>
                            <div class="channel">

                                <div>
                                    <span style="color: #87909A">{{item.last_name}}</span>
                                </div>

                                <div style="margin-left: 10px;margin-right: 10px;font-size: 10px">
                                    <span>加班工时:</span>
                                    <span style="color: #4A90E2" v-if="item.ot_hours !== 0">{{item.ot_hours}}小时</span>
                                    <span style="color: #4A90E2" v-else>无</span>

                                    <span style="margin-left: 20px">换休工时:</span>
                                    <span style="color: #7ED321" v-if="item.in_lieu_hours !== 0">{{item.in_lieu_hours}}小时</span>
                                    <span style="color: #7ED321" v-else>无</span>

                                    <div style="width:100%;height:1px;margin-top:-5px;margin-bottom:-5px;padding:0px;background-color:#9FA5AC;overflow:hidden;"></div>

                                    <span>其中:标准工时</span>
                                    <span v-if="item.al_hours !== 0">{{item.al_hours}}小时，</span>
                                    <span v-else>无,</span>

                                    <span>三薪工时 </span>
                                    <span v-if="item.legal_vacation_ot_hours !== 0">{{item.legal_vacation_ot_hours}}小时</span>
                                    <span v-else>无</span>

                                </div>

                            </div>

                        </el-form-item>
                    </el-col>

                </el-form>

            </div>


            <el-col :span="24">
                <div align="center">
                    <el-radio-group fill="#FF9901" v-model="tabPosition" :class="$style.grop" size="mini">
                        <el-radio-button label="ot">加班记录</el-radio-button>
                        <el-radio-button label="vacation">换休记录</el-radio-button>
                    </el-radio-group>
                </div>
            </el-col>


            <el-table
                    :data="tableOtData"
                    style="width: 100%"
                    :header-cell-style="tableHeaderColor" v-show="tabPosition === 'ot'">
                <el-table-column
                        label="日期"
                        prop="date"
                        align="center"
                        width="150">
                </el-table-column>
                <el-table-column
                        label="店员"
                        prop="last_name"
                        align="center">
                </el-table-column>
                <el-table-column
                        label="开始时间"
                        prop="start_date"
                        align="center">
                </el-table-column>
                <el-table-column
                        label="结束时间"
                        prop="end_date"
                        align="center">
                </el-table-column>
                <el-table-column
                        label="加班工时"
                        prop="ot_hours"
                        align="center">
                </el-table-column>
                <el-table-column
                        label="三薪工时"
                        prop="legal_vacation_hours"
                        align="center">
                </el-table-column>
                <el-table-column
                        label="事由"
                        prop="reason"
                        align="center">
                </el-table-column>
                <el-table-column
                        label="审批日期"
                        prop="approved_date"
                        align="center">
                </el-table-column>

            </el-table>


            <el-table
                    :data="tableVacationData"
                    style="width: 100%"
                    :header-cell-style="tableHeaderColor" v-show="tabPosition === 'vacation'">
                <el-table-column
                        label="日期"
                        prop="date"
                        align="center"
                        width="150">
                </el-table-column>
                <el-table-column
                        label="店员"
                        prop="last_name"
                        align="center">
                </el-table-column>
                <el-table-column
                        label="休假时长"
                        prop="leave_duration"
                        align="center">
                </el-table-column>
                <el-table-column
                        label="当天班次"
                        prop="icon_text"
                        align="center">
                </el-table-column>
                <el-table-column
                        label="换休工时"
                        prop="in_lieu_hours"
                        align="center">
                </el-table-column>
                <el-table-column
                        label="事由"
                        prop="reason"
                        align="center">
                </el-table-column>
                <el-table-column
                        label="审批日期"
                        prop="approved_date"
                        align="center">
                </el-table-column>

            </el-table>
        </el-row>

    </div>
</template>
<script>
    import Pagination from '../../../../components/pagination'
    import http from '../../../../APIService/http'
    import ElMenu from "element-ui/packages/menu/src/menu";
    import late_img from '../../../../assets/images/late_img.png'
    import absence_img from '../../../../assets/images/absence_img.png'
    import leave_img from '../../../../assets/images/leave_img.png'
    import ot_img from '../../../../assets/images/ot_img.png'
    import gps_icon from '../../../../assets/images/gps_icon.png'
    import moment from 'moment'

    export default {
        data() {

            return {
                id: '',
                title: '',


                tabPosition: 'ot',

                date: {},
                dateStr: "",
                shiftArray: [],
                late_img: late_img,
                absence_img: absence_img,
                leave_img: leave_img,
                ot_img: ot_img,
                gps_icon: gps_icon,
                Child: [{
                    id: 1,
                    name: 2
                }, {
                    id: 2,
                    name: 4
                }, {
                    id: 2,
                    name: 4
                }, {
                    id: 2,
                    name: 4
                }],
                tableQuarterData: [],
                tableOtData: [],
                tableVacationData: []
            }
        },
        created() {


            let obj = this.$store.getters.getStore
            this.id = obj.id
            this.title = obj.storeName
            this.shiftArray = obj.shiftArray

            if(obj.dateOne){
                this.date = obj.dateOne
            }else {
                this.date = moment()
            }
            this.dateStr = this.getCurrentDate()

            this.getOtResultByMonthly()
        },
        props: {
            item: {
                type: Object,
                default: () => {
                }
            },
            index: {
                type: Number,
                default: 0
            }
        },
        components: {
            ElMenu,
            Pagination
        },
        methods: {

            // 按月度统计
            async getOtResultByMonthly() {
                try {

                    this.loading = true
                    let data = {
                        store_id: this.id,
                        user_id: this.$store.getters.getUser.user_id,
                        tenant_id: this.$store.getters.getUser.tenant_id,
                        month: this.date.format("YYYY-MM")
                    }

                    await http.post('/wapi/v1/getOtResultByMonthly', data).then(res => {

                        this.tableQuarterData = res.data.quarter_data
                        this.tableOtData = res.data.ot_data
                        this.tableVacationData = res.data.vacation_data

                        this.loading = false

                        this.$store.commit('setStore', {
                            id: this.id,
                            dateOne:this.date,
                            storeName: this.title,
                            shiftArray:this.shiftArray
                        })

                    })
                } catch (err) {
                    this.loading = false
                    this.error()
                }
            },
            // 修改table header的背景色
            tableHeaderColor({row, column, rowIndex, columnIndex}) {
                if (rowIndex === 0) {
                    return 'background-color: #E0E0E0;color: #5C575E'
                }
            },
            getCurrentDate() {

                let date = moment(this.date)
                return date.year() + '年' +this.getFormatDate(date.month()+1)+ '月'


            },
            getFormatDate(arg){

                if (!arg) {
                    return '';
                }
                var re = arg + '';
                if (re.length < 2) {
                    re = '0' + re;
                }
                return re;
            },lastNextMonthClick(num) {

                let currentDate =  moment(this.date)
                let date = currentDate.add(num, "months")
                this.date = date
                this.dateStr = date.year() + '年' +this.getFormatDate(date.month()+1)+ '月'


                this.getOtResultByMonthly()

            }
        }
    }
</script>
<style lang="scss" module>
    @import '../../../../assets/css/default';

    .container {
        margin: 10px 0px;
        .month {
            margin-bottom: 15px;
        }
        .grop {
            margin-bottom: 10px;
            height: 30px;
            margin-top: 20px;
            margin-bottom: 15px;
            border: #FF9901
        }
        .text {
            font-size: 14px;
            color: #4D586D;
        }

        .span {
            display: inline-block;
            font-size: 12px;
            color: #FFFFFF;
            text-align: left;
            padding: 5px;
            background: #9B9B9B;
            border-radius: 3px;
            margin-left: 5px;
            margin-right: 5px;
        }
        .span_shift {
            font-size: 12px;
            color: #FFFFFF;
            text-align: center;
            padding: 5px;
            background: #9B9B9B;
            border-radius: 3px;
            margin-left: 5px;
            margin-right: 5px;
            max-width: 64px;
        }

        .demo-table-expand {
            font-size: 0;
        }
        .demo-table-expand label {
            width: 90px;
            color: #99a9bf;
        }
        .demo-table-expand .el-form-item {
            margin-right: 0;
            margin-bottom: 0;
            width: 100%;
        }
    }
</style>
<style scoped>

    .a_modal >>> .el-button {
        color: #646464;
    }

    .channel {
        border: solid 0.5px #87909A;
        padding-left: 10px;
        padding-right: 10px;
        color: #B0B5B9;

        font-size: 12px;
        border-radius: 4px;
        min-height: 58px;
        max-width: 280px;

        display: flex;
        align-items: center;
        justify-content: space-around;
        position: relative;
    }

</style>


// WEBPACK FOOTER //
// src/pages/attendance/overtimeDetails/item/monthlyItem.vue